// Single source of truth for the primary nav (mirrors approved-cockpit.js NAV).
// Consolidated into Kraken-style groups (owner request 2026-07-04): same routes,
// same labels, same icons — grouped so the rail reads as three scannable clusters
// instead of a 13-item flat list. Home stays ungrouped at the top.
export interface NavItem {
  label: string;
  href: string;
  icon: string;
}

export interface NavGroup {
  title: string; // '' = ungrouped (no header row)
  items: NavItem[];
}

export const NAV_GROUPS: NavGroup[] = [
  {
    title: '',
    items: [{ label: 'Home', href: '/', icon: 'H' }],
  },
  {
    title: 'Trade',
    items: [
      { label: 'Options', href: '/options', icon: 'O' },
      { label: 'Day Trade', href: '/daytrade', icon: 'D' },
      { label: 'Futures', href: '/futures', icon: 'F' },
      { label: 'Commodities', href: '/commodities', icon: 'M' },
      { label: 'Forex', href: '/forex', icon: 'X' },
      { label: 'Crypto', href: '/crypto', icon: 'B' },
    ],
  },
  {
    title: 'Intelligence',
    items: [
      { label: 'Event Signals', href: '/dashboard', icon: 'E' },
      { label: 'Pattern Engine', href: '/engine', icon: 'G' },
      { label: 'Caesar', href: '/caesar', icon: 'C' },
    ],
  },
  {
    title: 'Account',
    items: [
      { label: 'Paper Portfolio', href: '/portfolio', icon: 'P' },
      { label: 'Broker Accounts', href: '/broker', icon: 'K' },
      { label: 'Sandbox', href: '/sandbox', icon: 'S' },
    ],
  },
];

// Flat view preserved for any consumer that wants the simple list (e2e checks etc.).
export const NAV: NavItem[] = NAV_GROUPS.flatMap((g) => g.items);
